<style lang="stylus">
    .insertThemeColor-modal {
        width: 480px;

        .name-bar {
            display: flex;
            align-items: center;
            margin-top: 2px;
            margin-bottom: 24px;
            .label {
                width: 32px;
            }
            .input {
                height: 32px !important;
            }
        }
        .label {
            font-size: 12px;
            margin-right: 8px;
        }
        .themecolor-list {
            margin-top: 16px;
            margin-bottom: 24px;
            display: flex;
            column-gap: 15.7px;
            row-gap: 8px;
            flex-wrap: wrap;
            .themecolor-box {
                width: 32px;
                height: 32px;
                border: 2px solid #fff;
                box-sizing: border-box;
                border-radius: 50%;
                cursor: pointer;
                margin: 4px;
                &.active,
                &:hover {
                    outline: 2px solid #017fff;
                }
            }
        }
        .themecolor-name {
            input.ivu-input-default {
                height: 32px !important;
                border-radius: 8px !important;
                border-color: rgba(0, 0, 0, 0.08) !important;
            }
        }
    }
    .insertThemeText-modal {
        width: 352px;
        .themetext-set {
            height: 25px;
            margin-top: 2px;
            padding: 0 15px;
            display: flex;
            justify-content: space-between;
            .themetext-family {
                width: 196px;
                height: 25px;
            }
            .themetext-size {
                width: 85px;
                height: 25px;
                margin-left: 10px;
            }
            .showBox {
                width: 100%;
                height: 100%;
                border: 1px solid var(--border-color-theme-set-create-connector);
                background-color: var(--bg-color-tertiary);
                border-radius: 6px;
                transition: border-color 0.2s ease-in-out;
                padding: 3px 0;
                &:hover {
                    border-color: var(--themeHover);
                    cursor: pointer;
                }
                > p {
                    float: left;
                    padding-left: 10px;
                    width: calc(100% - 15px);
                }
            }
        }
        .themetext-name {
            padding: 0 15px;
            margin-top: 30px;
            margin-bottom: 24px;
        }
    }
    .insertThemeLine-modal {
        width: 400px;
        .dialog-slot {
            max-height: unset;
            overflow-y: unset;
        }
        .themeline-left {
            float: left;
            margin-left: 15px;
            width: 115px;
            .showBox {
                width: 100%;
                height: 100%;
                border: 1px solid var(--border-color-theme-set-create-connector);
                background-color: var(--bg-color-tertiary);
                border-radius: 6px;
                transition: border-color 0.2s ease-in-out;
                padding: 3px 0;
                &:hover {
                    border-color: var(--themeHover);
                    cursor: pointer;
                }
                .item-icon {
                    width: 95px;
                    height: 18px;
                    padding: 0 5px;
                    vertical-align: middle;
                }
            }
            .themeline-item {
                &:first-child {
                    margin-top: 2px;
                }
            }
        }
        .themeline-right {
            float: left;
            width: 170px;
            margin-left: 33px;
            .selectbox {
                width: 80px;
                height: 25px;
                float: left;
                & + div {
                    margin-left: 10px;
                }
                .showBox {
                    width: 100%;
                    height: 100%;
                    float: left;
                    border: 1px solid var(--border-color-theme-set-create-connector);
                    background-color: var(--bg-color-tertiary);
                    border-radius: 6px;
                    transition: border-color 0.2s ease-in-out;
                    padding: 3px 0;
                    &:hover {
                        border-color: var(--themeHover);
                        cursor: pointer;
                    }
                    .rotate {
                        transform: rotate(180deg) !important;
                    }
                    .item-icon {
                        width: 60px;
                        height: 18px;
                        padding: 0 5px;
                        vertical-align: middle;
                    }
                    > p {
                        float: left;
                        width: 50px;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        padding-left: 10px;
                    }
                }
            }
            .themeline-item {
                &:first-child {
                    margin-top: 2px;
                }
            }
        }

        .themeline-item {
            width: 100%;
            height: 48px;
            margin-top: 19px;
            position: relative;
            > p {
                margin-bottom: 5px;
            }
            .themeline-number {
                width: 100%;
                height: 25px;
                .ivu-input-number-handler-wrap, .ivu-input-number-input  {
                    background-color: var(--bg-color-tertiary);
                }

            }
            .selectbox {
                position: relative;
                border-radius: 6px;
                .linebox-selector {
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 30px;
                    width: 100%;
                    list-style: none;
                    background-color: var(--bg-color-tertiary);
                    box-shadow: $box-shadow;
                    z-index: 1;
                    max-height: 150px;
                    overflow-y: scroll;
                    &.stroke-style {
                        position: fixed;
                    }
                    > li {
                        height: 25px;
                        position: relative;
                        .rotate {
                            transform: translate(-50%, -50%) rotate(180deg) !important;
                        }
                        .item-icon {
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            width: 60px;
                            height: 18px;
                        }
                        .item-linestyle {
                            width: 80px !important;
                        }
                        &:hover {
                            background-color: var(--bg-color-ivu-select-item-hover);
                        }
                    }
                }
            }
        }
        .themelinename-item {
            width: 170px;
        }
        .dialog-slot {
            @media screen and (max-height: 768px) {
                overflow-y: inherit;
            }
        }
    }
    .insertTheme-modal {
        width: 352px;
        .theme-name {
            margin-bottom: 24px;
            input.ivu-input-small {
                height: 32px !important;
                border-radius: 8px !important;
                border-color: rgba(0, 0, 0, 0.08) !important;
            }
        }
    }
    /deep/ .ivu-input-wrapper {
        .ivu-input-small {
            height: 32px !important;
            border-radius: 8px !important;
            border-color: rgba(0, 0, 0, 0.08) !important;
        }
    }
</style>
<style lang="stylus">
    .insertTheme-mask
        .dialog-btnbox-normal
            border none
</style>

<template>
    <div class="insertTheme-mask" @click="showSelector('')">
        <Dialog class="insertTheme-modal" :title="$t('insertTheme.title')" v-if="insertThemetype == 0" :mask="true" @close="closeModal">
            <i-input class="theme-name" size="small" v-model="name" :placeholder="$t('insertTheme.placeholder')"></i-input>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="insertTheme()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>

        <Dialog class="insertThemeColor-modal" :title="$t('insertThemeColor.title')" v-if="insertThemetype == 1" :mask="true" @close="closeModal">
            <div class="name-bar">
                <span class="label">{{ $t("insertThemeLine.name") }}:</span>
                <i-input class="themecolor-name" v-model="name" :placeholder="$t('insertThemeColor.placeholder')"></i-input>
            </div>
            <div class="label">{{ $t("insertThemeColor.editTitle") }}</div>
            <div class="themecolor-list">
                <template v-for="(color, i) in colorList">
                    <div
                        class="themecolor-box"
                        :class="{ active: currentColorIndex === i }"
                        :key="i"
                        :style="{ backgroundColor: color }"
                        @click="showMoreColor($event, i, color)"
                        v-if="i < 8"
                    ></div>
                </template>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="insertTheme()">{{ $t("confirm") }}</div>
            </div>
        </Dialog>

        <Dialog class="insertThemeLine-modal" :title="$t('insertThemeLine.title')" v-if="insertThemetype == 2" :mask="true" @close="closeModal">
            <div style="height: 208px">
                <div class="themeline-left">
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.strokeWidth") }}</p>
                        <InputNumber
                            :active-change="false"
                            :formatter="(value) => `${value.toFixed(2)} pt`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :max="200"
                            :min="0.25"
                            :step="0.25"
                            size="small"
                            v-model="strokeWidth"
                            class="themeline-number"
                            style="width: 80px"
                        />
                    </div>
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.round") }}</p>
                        <InputNumber
                            :active-change="false"
                            :formatter="(value) => `${value} mm`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :max="9999"
                            :min="0"
                            :step="1"
                            size="small"
                            v-model="round"
                            class="themeline-number"
                            style="width: 80px"
                        />
                    </div>
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.strokeStyle") }}</p>
                        <div class="selectbox">
                            <div class="showBox" @click.stop="showSelector('strokeStyle')" ref="strokeStyle">
                                <iconSymbol class="item-icon" :name="activeDashTypeUrl(strokeStyle - 1)" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector stroke-style" v-show="showListType == 'strokeStyle'" :style="strokeStyleObj">
                                <li v-for="item in 23" :key="item" @click.stop="clickSelector('strokeStyle', item)">
                                    <iconSymbol class="item-icon item-linestyle" :name="activeDashTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="themeline-right">
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.arrowStyle") }}</p>
                        <div class="selectbox">
                            <div class="showBox" @click.stop="showSelector('beginStyle')">
                                <iconSymbol class="item-icon rotate" :name="activeBeginTypeUrl(arrowStyleBegin)" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector" v-show="showListType == 'beginStyle'">
                                <li v-for="item in 50" :key="item" @click.stop="clickSelector('beginStyle', item - 1)">
                                    <iconSymbol class="item-icon rotate" :name="activeBeginTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                        <div class="selectbox">
                            <div class="showBox" @click.stop="showSelector('endStyle')">
                                <iconSymbol class="item-icon" :name="activeBeginTypeUrl(arrowStyleEnd)" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector" v-show="showListType == 'endStyle'">
                                <li v-for="item in 50" :key="item" @click.stop="clickSelector('endStyle', item - 1)">
                                    <iconSymbol class="item-icon" :name="activeBeginTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.arrowSize") }}</p>
                        <div class="selectbox">
                            <i-select size="small" v-model="arrowSizeBegin" :transfer="true">
                                <i-option v-for="item in arrowSizeList" :value="item.id" :key="item.id">{{ $t(item.text) }}</i-option>
                            </i-select>
                        </div>
                        <div class="selectbox">
                            <i-select size="small" v-model="arrowSizeEnd" :transfer="true">
                                <i-option v-for="item in arrowSizeList" :value="item.id" :key="item.id">{{ $t(item.text) }}</i-option>
                            </i-select>
                        </div>
                    </div>
                    <div class="themeline-item themelinename-item">
                        <p>{{ $t("insertThemeLine.name") }}</p>
                        <i-input class="themeline-name" size="small" v-model="name" :placeholder="$t('insertThemeLine.placeholder')"></i-input>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="insertTheme()">{{ $t("confirm") }}</div>
            </div>
        </Dialog>

        <Dialog class="insertThemeText-modal" :title="$t('insertThemeText.title')" v-if="insertThemetype == 3" :mask="true" @close="closeModal">
            <div class="themetext-set">
                <div class="themetext-family">
                    <i-select size="small" v-model="fontFamily">
                        <i-option v-for="(item, i) in familyList" :value="item" :label="item" :key="i">{{ item }}</i-option>
                    </i-select>
                </div>
                <div class="themetext-size">
                    <i-select size="small" v-model="fontSize">
                        <i-option v-for="(item, i) in sizeList" :value="item" :label="item" :key="i">{{ item }}</i-option>
                    </i-select>
                </div>
            </div>
            <i-input class="themetext-name" size="small" v-model="name" :placeholder="$t('insertThemeText.placeholder')"></i-input>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="insertTheme()">{{ $t("confirm") }}</div>
            </div>
        </Dialog>

        <Dialog
            class="insertThemeText-modal editThemeText-modal"
            :title="$t('insertThemeText.editTitle')"
            v-if="insertThemetype == 5"
            :mask="true"
            @close="closeModal"
        >
            <div class="themetext-set">
                <div class="themetext-family">
                    <i-select size="small" v-model="fontFamily">
                        <i-option v-for="(item, i) in familyList" :value="item" :label="item" :key="i">{{ item }}</i-option>
                    </i-select>
                </div>
                <div class="themetext-size">
                    <i-select size="small" v-model="fontSize">
                        <i-option v-for="(item, i) in sizeList" :value="item" :label="item" :key="i">{{ item }}</i-option>
                    </i-select>
                </div>
            </div>
            <i-input class="themetext-name" v-model="name" :placeholder="$t('insertThemeText.placeholder')"></i-input>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="dialog-btn-ok" @click="insertTheme()">{{ $t("confirm") }}</div>
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
            </div>
        </Dialog>

        <Dialog class="insertThemeLine-modal" :title="$t('insertThemeLine.editTitle')" v-if="insertThemetype == 6" :mask="true" @close="closeModal">
            <div style="height: 208px">
                <div class="themeline-left">
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.strokeWidth") }}</p>
                        <InputNumber
                            :active-change="false"
                            :formatter="(value) => `${value.toFixed(2)} pt`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :max="200"
                            :min="0.25"
                            :step="0.25"
                            size="small"
                            v-model="strokeWidth"
                            class="themeline-number"
                            style="width: 80px"
                        />
                    </div>
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.round") }}</p>
                        <InputNumber
                            :active-change="false"
                            :formatter="(value) => `${value} mm`"
                            :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                            :max="9999"
                            :min="0"
                            :step="1"
                            size="small"
                            v-model="round"
                            class="themeline-number"
                            style="width: 80px"
                        />
                    </div>
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.strokeStyle") }}</p>
                        <div class="selectbox">
                            <div class="showBox" @click.stop="showSelector('strokeStyle')">
                                <iconSymbol class="item-icon" :name="activeDashTypeUrl(strokeStyle - 1)" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector" v-show="showListType == 'strokeStyle'">
                                <li v-for="item in 23" :key="item" @click.stop="clickSelector('strokeStyle', item)">
                                    <iconSymbol class="item-icon item-linestyle" :name="activeDashTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="themeline-right">
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.arrowStyle") }}</p>
                        <div class="selectbox">
                            <div class="showBox" @click.stop="showSelector('beginStyle')">
                                <iconSymbol class="item-icon rotate" :name="activeBeginTypeUrl(arrowStyleBegin)" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector" v-show="showListType == 'beginStyle'">
                                <li v-for="item in 50" :key="item" @click.stop="clickSelector('beginStyle', item - 1)">
                                    <iconSymbol class="item-icon rotate" :name="activeBeginTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                        <div class="selectbox">
                            <div class="showBox" @click.stop="showSelector('endStyle')">
                                <iconSymbol class="item-icon" :name="activeBeginTypeUrl(arrowStyleEnd)" />
                                <Icon type="ios-arrow-down" />
                            </div>
                            <ul class="linebox-selector" v-show="showListType == 'endStyle'">
                                <li v-for="item in 50" :key="item" @click.stop="clickSelector('endStyle', item - 1)">
                                    <iconSymbol class="item-icon" :name="activeBeginTypeUrl(item - 1)" />
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="themeline-item">
                        <p>{{ $t("insertThemeLine.arrowSize") }}</p>
                        <div class="selectbox">
                            <i-select size="small" v-model="arrowSizeBegin">
                                <i-option v-for="item in arrowSizeList" :value="item.id" :key="item.id">{{ $t(item.text) }}</i-option>
                            </i-select>
                        </div>
                        <div class="selectbox">
                            <i-select size="small" v-model="arrowSizeEnd" class="arrow-select">
                                <i-option v-for="item in arrowSizeList" :value="item.id" :key="item.id">{{ $t(item.text) }}</i-option>
                            </i-select>
                        </div>
                    </div>
                    <div class="themeline-item themelinename-item">
                        <p>{{ $t("insertThemeLine.name") }}</p>
                        <i-input class="themeline-name" size="small" v-model="name" :placeholder="$t('insertThemeLine.placeholder')"></i-input>
                    </div>
                </div>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="insertTheme()">{{ $t("confirm") }}</div>
            </div>
        </Dialog>

        <Dialog class="insertThemeColor-modal" :title="$t('insertThemeColor.editTitle')" v-if="insertThemetype == 7" :mask="true" @close="closeModal">
            <div class="name-bar">
                <span class="label">{{ $t("insertThemeLine.name") }}:</span>
                <i-input class="themecolor-name" v-model="name" :placeholder="$t('insertThemeColor.placeholder')"></i-input>
            </div>
            <div class="label">{{ $t("insertThemeColor.editTitle") }}</div>
            <div class="themecolor-list">
                <template v-for="(color, i) in colorList">
                    <div
                        class="themecolor-box"
                        :class="{ active: currentColorIndex === i }"
                        :key="i"
                        :style="{ backgroundColor: color }"
                        @click="showMoreColor($event, i, color)"
                        v-if="i < 8"
                    ></div>
                </template>
            </div>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="insertTheme()">{{ $t("confirm") }}</div>
            </div>
        </Dialog>

        <Dialog class="insertTheme-modal" :title="$t('renameTheme.title')" v-if="insertThemetype == 4" :mask="true" @close="closeModal">
            <i-input class="theme-name" size="small" v-model="name" :placeholder="$t('insertTheme.placeholder')"></i-input>
            <div class="dialog-btnbox-normal" :style="{ direction: !internal ? 'ltr' : 'rtl' }">
                <div class="" @click="closeModal()">{{ $t("cancel") }}</div>
                <div class="dialog-btn-ok" @click="renameTheme2()">{{ $t("confirm") }}</div>
            </div>
        </Dialog>
    </div>
</template>

<script lang="ts">
    /**!!
 api: [createTheme, createThemeColor, clrThemeID, cntThemeID, effThemeID, textThemeID,
 createLineTheme, width, round, dash, arrowStyleBegin, arrowStyleEnd, arrowSizeBegin, arrowSizeEnd,
 createThemeFonts, font, size, renameTheme, getDisplayColor]
 common: []
!!**/
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    import { limitThemeId, limitThemeColorId } from "@/app/utils/constant";
    declare var ThemeManager: any;
    @Component({
        components: {
            Dialog,
        },
    })
    export default class insertTheme extends Vue {
        @Inject()
        ["showMessage"];

        strokeStyleObj = {
            top: "0px",
            left: "0px",
            width: "0px",
        };
        showListType: string = "";
        name: string = "";

        fontFamily: string = "宋体";
        fontSize: number = 10;

        strokeWidth: number = 0.75;
        round: number = 0;
        strokeStyle: number = 1;
        arrowStyleBegin: number = 0;
        arrowStyleEnd: number = 0;
        arrowSizeBegin: number = 4;
        arrowSizeEnd: number = 4;
        arrowSizeList: Array<Object> = [
            {
                id: 2,
                text: "Very Small",
            },
            {
                id: 3,
                text: "Small",
            },
            {
                id: 4,
                text: "Middle",
            },
            {
                id: 6,
                text: "Large",
            },
            {
                id: 9,
                text: "Extra Large",
            },
            {
                id: 12,
                text: "Jumbo",
            },
            {
                id: 14,
                text: "Colossal",
            },
        ];
        sizeList: Array<number> = [6, 7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
        familyList: Array<string> = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "sans-serif",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
            "仿宋",
            "楷体",
            "隶书",
            "微软雅黑",
            "黑体",
            "宋体",
            "华文楷体",
            "华文行楷",
            "华文新魏",
        ];
        enFamily: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
        ];
        zhFamily: string[] = ["仿宋", "楷书", "隶书", "微软雅黑", "黑体", "宋体", "华文楷体", "华文行楷", "华文新魏"];
        closeModal() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: false,
            });
            this.initData();
            this.renameThemeID = 0;
            this.tempColorList = [];
        }

        checkLimitColor() {
            // true 未更改颜色
            if (this.tempColorList.length > 0) {
                if (this.colorList.length != this.tempColorList.length) return false;
                for (let i = 0; i < this.colorList.length; i++) {
                    if (this.colorList[i] != this.tempColorList[i]) {
                        return false;
                    }
                }
                return true;
            }
            return false;
        }
        insertTheme() {
            let view = window["_view"];
            if (!view) return;
            let msgNoName = this.$t("noName");
            let msgExist = this.$t("existTheme");
            let flag: boolean;

            if (this.insertThemetype == 0) {
                msgNoName = this.$t("noName");
            } else if (this.insertThemetype == 1) {
                //insert theme color
                msgNoName = this.$t("noColorName");
            } else if (this.insertThemetype == 2) {
                //insert theme line
                msgNoName = this.$t("noLineName");
            } else if (this.insertThemetype == 3) {
                //insert theme text
                msgNoName = this.$t("noTextName");
            }
            if (!this.name) {
                this.showMessage({
                    type: 2,
                    content: msgNoName,
                });
                return;
            }

            if (this.insertThemetype == 0) {
                let payload = {
                    clrThemeID: this.theme.clrThemeID,
                    cntThemeID: this.theme.cntThemeID,
                    effThemeID: this.theme.effThemeID,
                    textThemeID: this.theme.textThemeID,
                };
                flag = view.createTheme(this.name, this.theme, this.theme.themeID);
            } else if (this.insertThemetype == 1) {
                //insert theme color
                let fromId = this.checkLimitColor() ? this.theme.clrThemeID : -1;
                msgNoName = this.$t("noColorName");
                flag = view.createThemeColor(this.name, this.colorList.slice(), fromId);
            } else if (this.insertThemetype == 2) {
                //insert theme line
                msgNoName = this.$t("noLineName");
                let payload = {
                    width: this.strokeWidth,
                    round: this.round,
                    dash: this.strokeStyle,
                    arrowStyleBegin: this.arrowStyleBegin,
                    arrowStyleEnd: this.arrowStyleEnd,
                    arrowSizeBegin: this.arrowSizeBegin,
                    arrowSizeEnd: this.arrowSizeEnd,
                };
                flag = view.createLineTheme(this.name, payload);
            } else if (this.insertThemetype == 3) {
                //insert theme text
                msgNoName = this.$t("noTextName");
                let payload = {
                    font: this.fontFamily,
                    size: this.fontSize,
                };
                flag = view.createThemeFonts(this.name, payload);
            } else if (this.insertThemetype == 5) {
                msgNoName = this.$t("noTextName");
                let payload = {
                    textFont: this.fontFamily,
                    textSize: this.fontSize,
                };
                flag = view.editThemeFonts(this.name, payload, this.editTextOrigin._id);
            } else if (this.insertThemetype == 6) {
                msgNoName = this.$t("noTextName");
                let payload = {
                    lineWidth: this.strokeWidth,
                    lineRound: this.round,
                    lineDash: this.strokeStyle,
                    lineArrowStyleBegin: this.arrowStyleBegin,
                    lineArrowStyleEnd: this.arrowStyleEnd,
                    lineArrowSizeBegin: this.arrowSizeBegin,
                    lineArrowSizeEnd: this.arrowSizeEnd,
                };
                flag = view.editLineTheme(this.name, payload, this.editLineOrigin._id);
            } else if (this.insertThemetype == 7) {
                msgNoName = this.$t("noColorName");
                let payload = {
                    _clrs: this.colorList,
                };
                let isChange = !this.checkLimitColor();
                flag = view.editThemeColor(this.name, payload, this.editColorOrigin._id);
            }
            if (flag) this.closeModal();
            else if (flag == false) {
                this.showMessage({
                    type: 2,
                    content: msgExist,
                });
            } else console.log("error");
            this.$bus.$emit("refreshTheme");
        }

        renameTheme2() {
            let view = window["_view"];
            if (!view) return;
            let msgNoName = this.$t("noName");
            let msgExist = this.$t("existTheme");

            if (!this.name) {
                this.showMessage({
                    type: 2,
                    content: msgNoName,
                });
                return;
            }
            if (this.name == this.renameThemeName) this.closeModal();

            let flag = view.renameTheme(this.renameThemeID, this.name);
            if (flag) this.closeModal();
            else {
                this.showMessage({
                    type: 2,
                    content: msgExist,
                });
            }
        }

        showSelector(type: string) {
            this.showListType = type;
            if (type === "strokeStyle") {
                this.$nextTick(() => {
                    let sibling = this.$refs.strokeStyle as HTMLElement;
                    let rect = sibling.getBoundingClientRect();

                    let w = sibling.offsetWidth;
                    let h = sibling.offsetHeight;
                    let left = sibling.offsetLeft;
                    let top = sibling.offsetTop;
                    console.log(w, h, left, top);
                    this.strokeStyleObj.left = `${rect.left}px`;
                    this.strokeStyleObj.top = `${rect.top + rect.height + 6}px`;
                    this.strokeStyleObj.width = `${rect.width}px`;
                });
            }
        }

        clickSelector(type: string, i: number) {
            if (type == "strokeStyle") this.strokeStyle = i;
            else if (type == "beginStyle") this.arrowStyleBegin = i;
            else if (type == "endStyle") this.arrowStyleEnd = i;
            else if (type == "beginSize") this.arrowSizeBegin = i;
            else if (type == "beginSize") this.arrowSizeEnd = i;
            this.showSelector("");
        }

        currentColorIndex = -1;
        showMoreColor(e, i, color) {
            let node = e.target;
            this.currentColorIndex = i;
            let payload = {
                type: this.fmtType.themeColor,
                index: i,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "123456" });
            });
        }

        tempColorList = [];
        initData() {
            this.name = "";
            this.colorList = window["_view"].getDisplayColor(this.theme.clrThemeID);
            if (!this.vip) {
                this.tempColorList = JSON.parse(JSON.stringify(this.colorList));
            }
            // this.colorList = ['#96a6a6', '#1bbc9d', '#3498db', '#2da2bf', '#ee7c31', '#ffaf00',
            // '#dd7195', '#527294', '#fca798', '#e0b805'/*, '#eb6d71', '#b296b8'*/];
        }

        activeDashTypeUrl(index) {
            return "dt" + index;
        }

        activeBeginTypeUrl(index) {
            return "arrow-" + index;
        }

        get renameThemeName() {
            return this.$store.state.ui.renameThemeName;
        }

        get insertThemetype() {
            return this.$store.state.ui.insertThemetype;
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }

        get colorList() {
            return this.$store.state.ui.themeColorList;
        }

        set colorList(v) {
            this.$store.commit("setStatus", {
                type: "themeColorList",
                data: v,
            });
        }

        get renameThemeID() {
            return this.$store.state.ui.renameThemeID;
        }

        set renameThemeID(v) {
            this.$store.state.ui.renameThemeID = v;
        }

        get theme() {
            return this.$store.state.page.theme;
        }

        get editTextOrigin() {
            return this.$store.state.ui.editTextOrigin;
        }

        get editLineOrigin() {
            return this.$store.state.ui.editLineOrigin;
        }

        get editColorOrigin() {
            return this.$store.state.ui.editColorOrigin;
        }

        parseQueryString(queryString) {
            const pairs = queryString.split("&");
            return pairs.reduce((acc, pair) => {
                const [key, value] = pair.split("=");
                acc[key] = value;
                return acc;
            }, {});
        }

        mounted() {
            if (this.lang == "zh") {
                this.familyList = this.zhFamily.concat(this.enFamily);
            } else {
                this.familyList = this.enFamily.concat(this.zhFamily);
            }
            if (this.insertThemetype == 4) {
                this.name = this.renameThemeName;
            }
            if (this.insertThemetype == 5) {
                this.$nextTick(() => {
                    this.name = this.editTextOrigin.localName(this.lang);
                    let textEditInfo = this.parseQueryString(this.editTextOrigin.getTextEditInfo());
                    this.fontFamily = textEditInfo._font;
                    this.fontSize = Number(textEditInfo._textFontSize) || 10;
                });
            }
            if (this.insertThemetype == 6) {
                this.$nextTick(() => {
                    this.name = this.editLineOrigin.localName(this.lang);
                    const { _width, _round, _dash, _startArrowID, _endArrowID, _startSize, _endSize } = this.parseQueryString(
                        this.editLineOrigin.getLineEditInfo()
                    );
                    this.strokeWidth = Number(_width) || 0.75;
                    this.round = Number(_round);
                    this.strokeStyle = Number(_dash) || 1;
                    this.arrowStyleBegin = Number(_startArrowID);
                    this.arrowStyleEnd = Number(_endArrowID);
                    this.arrowSizeBegin = Number(_startSize);
                    this.arrowSizeEnd = Number(_endSize);
                });
            }
            if (this.insertThemetype == 7) {
                this.$nextTick(() => {
                    this.name = this.editColorOrigin.localName(this.lang);
                    this.colorList = this.editColorOrigin.displayColor();
                });
            }
        }

        created() {
            this.initData();
        }
    }
</script>
<i18n>
{
  "zh": {
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "insertTheme": {
      "title": "插入主题",
      "placeholder": "主题名称"
    },
    "insertThemeColor": {
      "title": "创建主题颜色",
      "editTitle": "编辑主题颜色",
      "placeholder": "主题色名称",
      "nameLabel": "名称",
      "colorEditLabel": "主题名称编辑"
    },
    "insertThemeText": {
      "title": "添加字体",
      "placeholder": "文本名称",
      "editTitle": "编辑字体"
    },
    "insertThemeLine": {
      "title": "创建连接线",
      "editTitle": "编辑连接线",
      "placeholder": "连接线名称",
      "strokeWidth": "线条宽度",
      "round": "圆角大小",
      "strokeStyle": "线条样式",
      "arrowStyle": "箭头样式",
      "arrowSize": "箭头大小",
      "name": "名称"
    },
    "renameTheme": {
      "title": "重命名主题"
    },
    "confirm": "确定",
    "cancel": "取消",
    "noName": "请输入主题名",
    "noColorName": "请输入颜色名",
    "noLineName": "请输入连接线名",
    "noTextName": "请输入文本名",
    "existTheme": "该主题名已存在，请重新输入"
  },
  "fr": {
    "Very Small": "Très Petit",
    "Small": "Petit",
    "Middle": "Moyen",
    "Large": "Grand",
    "Extra Large": "Très Grand",
    "Jumbo": "Géant",
    "Colossal": "Colossal",
    "insertTheme": {
      "title": "Insérer Sujet",
      "placeholder": "Nom du Sujet"
    },
    "insertThemeColor": {
      "title": "Insérer Couleur",
      "editTitle": "Modifier les couleurs du thème",
      "placeholder": "Nom de la couleur de Thème ",
      "nameLabel": "名称",
      "colorEditLabel": "主题名称编辑"
    },
    "insertThemeText": {
      "title": "Ajouter une Police",
      "editTitle": "Modifier le texte du thème",
      "placeholder": "Nom du texte"
    },
    "insertThemeLine": {
      "title": "Créer un Connecteur",
      "editTitle": "Modifier le style de thème",
      "placeholder": "Nom du Connecteur",
      "strokeWidth": "Largeur de Ligne",
      "round": "Taille du Filet",
      "strokeStyle": "Style de Ligne",
      "arrowStyle": "Style de Flèche",
      "arrowSize": "Taille de Flèche ",
      "name": "Nom"
    },
    "renameTheme": {
      "title": "Renommer le Thème"
    },
    "confirm": "Confirmer",
    "cancel": "Annuler",
    "noName": "Veuillez Entrer un Nom de Sujet",
    "noColorName": "Veuillez Entrer un Nom de Couleur",
    "noLineName": "Veuillez Entrer un Nom de Connecteur",
    "noTextName": "Veuillez Entrer un nom de texte",
    "existTheme": "Le nom du thème existe déjà, veuillez ressaisir"
  },
  "de": {
    "Very Small": "Sehr klein",
    "Small": "Klein",
    "Middle": "Mittel",
    "Large": "Groß",
    "Extra Large": "sehr Groß",
    "Jumbo": "Rießig",
    "Colossal": "Übergroß",
    "insertTheme": {
      "title": "Thema einfügen",
      "placeholder": "Name des Themas"
    },
    "insertThemeColor": {
      "title": "Farbe einfügen  ",
      "editTitle": "Farbdesigns bearbeiten",
      "placeholder": "Themenfarbe"
    },
    "insertThemeText": {
      "title": "Schriftart einfügen",
      "editTitle": "Designtext bearbeiten",
      "placeholder": "Textname "
    },
    "insertThemeLine": {
      "title": "Verbinder erstellen",
      "editTitle": "Designstil bearbeiten",
      "placeholder": "Verbindersname",
      "strokeWidth": "Linienbreiten",
      "round": "Größe der Rundecke",
      "strokeStyle": "Linienstil",
      "arrowStyle": "Pfeilsart",
      "arrowSize": "Pfeilsgröße",
      "name": "Titel"
    },
    "renameTheme": {
      "title": "Titel benennen"
    },
    "confirm": "Sichern",
    "cancel": "Abbrechen",
    "noName": "Themenname eingeben",
    "noColorName": "Bitte den Farbnamen eingeben",
    "noLineName": "Bitte den Verbindungsliniennamen eingeben",
    "noTextName": "Bitte den Textnamen eingeben",
    "existTheme": "Der Themenname existiert bereits. Bitte versuchen Sie es erneut"
  },
  "en": {
    "Very Small": "Very Small",
    "Small": "Small",
    "Middle": "Middle",
    "Large": "Large",
    "Extra Large": "Extra Large",
    "Jumbo": "Jumbo",
    "Colossal": "Colossal",
    "insertTheme": {
      "title": "Create Theme",
      "placeholder": "Theme Name"
    },
    "insertThemeColor": {
      "title": "Create Theme Color",
      "editTitle": "Edit Theme Colors",
      "placeholder": "Color Name"
    },
    "insertThemeText": {
      "title": "Add a Theme Font",
      "editTitle": "Edit Theme Text",
      "placeholder": "Font Name"
    },
    "insertThemeLine": {
      "title": "Create a Theme Connector",
      "editTitle": "Edit Theme Style",
      "placeholder": "Connector Name",
      "strokeWidth": "Line Weight",
      "round": "Round",
      "strokeStyle": "Dashes",
      "arrowStyle": "Arrows",
      "arrowSize": "Arrow Size",
      "name": "Name"
    },
    "renameTheme": {
      "title": "Rename Theme"
    },
    "confirm": "OK",
    "cancel": "Cancel",
    "noName": "Enter Theme Name",
    "noColorName": "Please enter the color name.",
    "noLineName": "Please enter the connecting line name.",
    "noTextName": "Please enter the text name.",
    "existTheme": "The theme name already exists，please retry."
  },
  "jp": {
    "Very Small": "小さな",
    "Small": "小さい",
    "Middle": "真ん中",
    "Large": "大きい",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "insertTheme": {
      "title": "テーマを挿入",
      "placeholder": "名前"
    },
    "insertThemeColor": {
      "title": "テーマ色を挿入",
      "editTitle": "テーマの色を編集",
      "placeholder": "名前"
    },
    "insertThemeText": {
      "title": "テーマフォントを追加",
      "editTitle": "テーマのテキストを編集",
      "placeholder": "名前"
    },
    "insertThemeLine": {
      "title": "コネクターを新規作成",
      "editTitle": "テーマのスタイルを編集",
      "placeholder": "名前",
      "strokeWidth": "線の太さ",
      "round": "曲がりのスタイル",
      "strokeStyle": "線の種類",
      "arrowStyle": "矢印の種類",
      "arrowSize": "矢印のサイズ",
      "name": "名前"
    },
    "renameTheme": {
      "title": "テーマ名を変更"
    },
    "confirm": "OK",
    "cancel": "キャンセル",
    "noName": "テーマ名を入力してください",
    "noColorName": "色の名前を入力してください",
    "noLineName": "接続線の名前を入力してください",
    "noTextName": "テキストの名前を入力してください",
    "existTheme": "テーマ名は既に存在します。再入力してください。"
  },
  "es": {
    "Very Small": "Muy pequeño",
    "Small": "Pequeño",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Extra grande",
    "Jumbo": "Jumbo",
    "Colossal": "Colosal",
    "insertTheme": {
      "title": "Insertar tema",
      "placeholder": "Nombre del tema"
    },
    "insertThemeColor": {
      "title": "Crear el color del tema",
      "editTitle": "Editar colores del tema",
      "placeholder": "Nombre del color"
    },
    "insertThemeText": {
      "title": "Añadir una fuente temática",
      "editTitle": "Editar texto del tema",
      "placeholder": "Nombre de la fuente"
    },
    "insertThemeLine": {
      "title": "Crear un conector temático",
      "editTitle": "Editar estilo de tema",
      "placeholder": "Nombre del conector",
      "strokeWidth": "Peso de la línea",
      "round": "Redondo",
      "strokeStyle": "Guiones",
      "arrowStyle": "Flechas",
      "arrowSize": "Tamaño de la flecha",
      "name": "Nombre"
    },
    "renameTheme": {
      "title": "Renombrar tema"
    },
    "confirm": "Aceptar",
    "cancel": "Cancelar",
    "noName": "Introduzca el nombre del tema",
    "noColorName": "Por favor, introduzca el nombre del color",
    "noLineName": "Por favor, introduzca el nombre de la línea de conexión",
    "noTextName": "Por favor, introduzca el nombre de texto",
    "existTheme": "El nombre del tema ya existe，por favor, reintentar"
  },
  "pt": {
    "Very Small": "Muito Pequeno",
    "Small": "Pequeno",
    "Middle": "Médio",
    "Large": "Grande",
    "Extra Large": "Muito Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossal",
    "insertTheme": {
      "title": "Criar Tema",
      "placeholder": "Nome de Tema"
    },
    "insertThemeColor": {
      "title": "Criar Cor de Tema",
      "editTitle": "Editar cores de tema",
      "placeholder": "Nome de Cor"
    },
    "insertThemeText": {
      "title": "Adicionar uma Fonte de Tema",
      "editTitle": "Editar texto do tema",
      "placeholder": "Nome de Fonte"
    },
    "insertThemeLine": {
      "title": "Criar um Conector de Tema",
      "editTitle": "Editar estilo de tema",
      "placeholder": "Nome de Conector",
      "strokeWidth": "Peso da Linha",
      "round": "Redondo",
      "strokeStyle": "Traços",
      "arrowStyle": "Setas",
      "arrowSize": "Tamanho da Seta",
      "name": "Nome"
    },
    "renameTheme": {
      "title": "Renomear Tema"
    },
    "confirm": "OK",
    "cancel": "Cancelar",
    "noName": "Inserir Nome do Tema",
    "noColorName": "Por favor, inserir o nome da cor.",
    "noLineName": "Por favor, inserir o nome da linha de conexão.",
    "noTextName": "Por favor, inserir o nome do texto.",
    "existTheme": "O nome do tema já existe, por favor, repetir."
  },
  "it": {
    "Very Small": "Molto Piccolo",
    "Small": "Piccolo",
    "Middle": "Medio",
    "Large": "Grande",
    "Extra Large": "Molto Grande",
    "Jumbo": "Enorme",
    "Colossal": "Colossale",
    "insertTheme": {
      "title": "Crea Tema",
      "placeholder": "Nome Tema"
    },
    "insertThemeColor": {
      "title": "Crea Colore Tema",
      "editTitle": "Modifica i colori del tema",
      "placeholder": "Nome Colore"
    },
    "insertThemeText": {
      "title": "Aggiungi Font del Tema",
      "editTitle": "Modifica il testo del tema",
      "placeholder": "Nome Font"
    },
    "insertThemeLine": {
      "title": "Crea Connettore per il Tema",
      "editTitle": "Modifica lo stile del tema",
      "placeholder": "Nome Connettore",
      "strokeWidth": "Spessore Linea",
      "round": "Rotondo",
      "strokeStyle": "Trattini",
      "arrowStyle": "Frecce",
      "arrowSize": "Dimensione Freccia",
      "name": "Nome"
    },
    "renameTheme": {
      "title": "Rinomina Tema"
    },
    "confirm": "OK",
    "cancel": "Annulla",
    "noName": "Immettere il nome del tema",
    "noColorName": "Immettere il nome del colore.",
    "noLineName": "Immettere il nome della linea di connessione.",
    "noTextName": "Immettere il nome del testo.",
    "existTheme": "Esiste già un tema con questo nome. Si prega di sceglierne un altro."
  },
  "tw": {
    "Very Small": "非常小",
    "Small": "小",
    "Middle": "中",
    "Large": "大",
    "Extra Large": "特大",
    "Jumbo": "巨大",
    "Colossal": "超大",
    "insertTheme": {
      "title": "插入主題",
      "placeholder": "主題名稱"
    },
    "insertThemeColor": {
      "title": "插入顏色",
      "placeholder": "主題色名稱"
    },
    "insertThemeText": {
      "title": "添加字型",
      "placeholder": "文本名稱"
    },
    "insertThemeLine": {
      "title": "建立連接線",
      "placeholder": "連接線名稱",
      "strokeWidth": "線條寬度",
      "round": "圓角大小",
      "strokeStyle": "線條樣式",
      "arrowStyle": "箭頭樣式",
      "arrowSize": "箭頭大小",
      "name": "名稱"
    },
    "renameTheme": {
      "title": "重命名主題"
    },
    "confirm": "確定",
    "cancel": "取消",
    "noName": "請輸入主題名",
    "noColorName": "請輸入顏色名",
    "noLineName": "請輸入連接線名",
    "noTextName": "請輸入文本名",
    "existTheme": "該主題名已存在，請重新輸入"
  },
  "kr": {
    "Very Small": "매우 작다",
    "Small": "소",
    "Middle": "중",
    "Large": "대",
    "Extra Large": "특대",
    "Jumbo": "거대",
    "Colossal": "초대형",
    "insertTheme": {
      "title": "주제 삽입",
      "placeholder": "주제 이름"
    },
    "insertThemeColor": {
      "title": "색깔 삽입",
      "placeholder": "주제 색깔 이름"
    },
    "insertThemeText": {
      "title": "글꼴 추가",
      "placeholder": "텍스트 이름"
    },
    "insertThemeLine": {
      "title": "연결선 만들기",
      "placeholder": "연결선 이름",
      "strokeWidth": "라인 너비",
      "round": "원각 크기",
      "strokeStyle": "라인 스타일",
      "arrowStyle": "화살표 스타일",
      "arrowSize": "화살표 크기",
      "name": "이름"
    },
    "renameTheme": {
      "title": "주제 이름 바꾸기"
    },
    "confirm": "확인 ",
    "cancel": "취소 ",
    "noName": "주제 이름을 입력해주세요",
    "noColorName": "색깔 이름을 입력해주세요",
    "noLineName": "연결선 이름을 입력해주세요 ",
    "noTextName": "텍스트 이름을 입력해주세요",
    "existTheme": "이 주제 이름은 이미 존재합니다. 다시 입력해 주세요."
  }
}
</i18n>
